<div class="profile-icon-button">
  @if (user$ | async; as user) {
    <div>
      <pt-user-icon
        matRipple
        [name]="user.name"
        [src]="user | profileImage$ | async"
        [diameter]="iconSize"
        [matMenuTriggerFor]="accountMenu"
      />
      <mat-icon
        *ngIf="isManagementUser$ | async"
        class="management-user-icon"
        matTooltip="Management User"
        [matMenuTriggerFor]="accountMenu"
        >admin_panel_settings</mat-icon
      >
    </div>

    <mat-menu #accountMenu="matMenu">
      <ng-template matMenuContent>
        <pr-auth-user-card [user]="user" />

        @if (hasWorkspaces$ | async) {
          <button
            class="change-workspace"
            mat-menu-item
            (click)="changeWorkspace()"
          >
            Change Workspace
            <span class="workspace-slug"
              >({{ workspace.workspace$ | async }})</span
            >
          </button>
        }

        <mat-divider />

        <mat-nav-list dense>
          <a mat-list-item (click)="auth.logout()">Sign Out</a>
        </mat-nav-list>
      </ng-template>
    </mat-menu>
  }
</div>
